import useGetSubscription from './useGetSubscription';

export default function useGetPlanSettings() {
    const { userSubscription, isLoading } = useGetSubscription();
    const settings = userSubscription?.plan_details.settings;

    return {
        isLoading,
        allowWhiteLabel: settings ? (settings.allow_white_label_reports as boolean) : undefined,
        allowAIContentAnalysis: settings ? (settings.allow_ai_content_analysis as boolean) : undefined,
        allowLLMVisibility: settings ? (settings.allow_llm_visibility_checker as boolean) : undefined,
        allowVisualSeoAnalysis: settings ? (settings.allow_visual_seo_analysis as boolean) : undefined,
        allowCompetitorSOV: settings ? (settings.allow_competitor_sov as boolean) : undefined,
        maxKeywords: settings ? (settings.max_keywords as number) : undefined,
        maxCompetitors: settings ? (settings.max_competitors as number) : undefined,
        maxRegions: settings ? (settings.max_monitored_regions as number) : undefined,
        maxTrackedWebsites: settings ? (settings.max_tracked_websites as number) : undefined,
        dpMaxServiceableUrls: settings ? (settings.dp_max_urls as number) : undefined,
        dpMaxDomains: settings ? (settings.dp_max_domains as number) : undefined,
    };
}
